import {
	createApp
} from 'vue'

import App from './App.vue'
import apiAxios from '../../config/request.js'
import baseFunc from '../../config/base_func.js';
import 'ant-design-vue/dist/antd.css';
import Antd from 'ant-design-vue';
import '/src/assets/css/comment.css';


const app = createApp(App);
app.directive('autoHeight', {
	// 当被绑定的元素挂载到 DOM 中时……
	mounted(el, binding) {
		el.addEventListener("keyup", () => {
			autoHeight(el);
		})
	},

})
app.directive('focus', {
	// 当被绑定的元素挂载到 DOM 中时……
	mounted(el) {
		// 聚焦元素
		el.focus();
		// 选中内容
		el.select();
	},

})
function autoHeight(elem) {
    elem.style.height = "auto";
    elem.scrollTop = 0; // 防抖动
    elem.style.height = elem.scrollHeight + "px";
}
app.config.globalProperties.$apiRequest = apiAxios; 
app.config.globalProperties.$baseFunc = baseFunc; 
//将实例挂载至节点
app.use(Antd).mount('#app')
